import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'

Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  fetchData: { url: '/auth/me/?include=company', method: 'GET', enabled: true },
  logoutData: { url: 'auth/logout', method: 'POST', redirect: '/login', makeRequest: true },
  refreshData: { url: 'auth/refresh', method: 'POST', enabled: true, interval: 30 },
  forbiddenRedirect: { path: '/access-error' }
})
